<template>
  <component
    v-if="btn.btn_link"
    :is="component"
    :to="sameSite ? to : null"
    :href="sameSite ? null : btn.btn_link"
    :target="btn.btn_new_tab ? '_blank' : null"
    :class="['button -right', { '-light': parentBgColor === 'blue' }]"
  >
    {{ btn.btn_text }}

    <div class="button__icon">
      <Icon id="arrow" />
    </div>
  </component>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'ButtonArrow',

  components: {
    Icon,
  },

  props: {
    btn: {
      type: Object,
      required: true,
    },

    parentBgColor: {
      type: String,
      required: true,
    },
  },

  computed: {
    isAnchor() {
      return this.btn.btn_link.startsWith('#')
    },

    sameSite() {
      return this.isAnchor || this.btn.btn_link.startsWith(window.location.origin)
    },

    component() {
      return this.sameSite ? 'RouterLink' : 'a'
    },

    to() {
      if (this.isAnchor) {
        return {
          hash: this.btn.btn_link,
        }
      }

      if (!this.sameSite) {
        return null
      }

      return this.btn.btn_link.replace(window.location.origin, '')
    },
  },
}
</script>
